var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "loading-spinner"
  }, [_c('div', {
    staticClass: "loading-spinner-body"
  }, [_c('div', {
    staticClass: "spinner-box"
  }), _c('h5', {
    staticClass: "label"
  }, [_vm._v(_vm._s(_vm.label))]), _c('p', [_vm._v("Loading...")])])]);

}
var staticRenderFns = []

export { render, staticRenderFns }